
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class AuthorizeDialog extends Serenity.PropertyDialog<any, any>
    {

        protected form = new AuthorizeForm(this.idPrefix);
        public entityId: number;
        public voucherno: string;
        public vouchertypeid: number;
        public inst;
        public checksuccess: boolean;
        constructor() {
            super();

            this.form = new AuthorizeForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Authorize";
        }

      


        protected getDialogButtons(){
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.Username.value == null ||
                            Q.isEmptyOrNull(this.form.Username.value)) {
                            Q.notifyError("Please Enter Username!");
                            return;
                        }
                        if (this.form.Password.value == null ||
                            Q.isEmptyOrNull(this.form.Password.value)) {
                            Q.notifyError("Please Enter Password!");
                            return;
                        }

                        POSSalesService.Authorize({                            
                            Username: this.form.Username.value.toString(),
                            Password: this.form.Password.value.toString(),
                            VoucherNo: this.voucherno,
                            VoucherTypeId: this.vouchertypeid,
                            Remark: this.form.Remark.value.toString()
                        }, response => {
                            //Q.notifyInfo(
                            //    'Inserted: ' + (response.Inserted || 0) +
                            //    ', Updated: ' + (response.Updated || 0));

                            //if (response.ErrorList != null && response.ErrorList.length > 0) {
                            //    Q.notifyError(response.ErrorList.join(',\r\n '));
                            //}
                                Q.notifySuccess('Success');
                                this.checksuccess = true;
                                this.dialogClose();
                                return true;
                        }, { async: false });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}